import React, {Component} from 'react';
import {createMuiTheme, MuiThemeProvider} from '@material-ui/core/styles';
import MomentUtils from '@date-io/moment';
import {MuiPickersUtilsProvider} from 'material-ui-pickers';
import {Redirect, Route, Switch} from 'react-router-dom';
import {connect} from 'react-redux';
import {IntlProvider} from 'react-intl';
import 'assets/vendors/style';
import MainApp from 'app/index';
import RTL from 'util/RTL';
import asyncComponent from 'util/asyncComponent';
import defaultTheme from './themes/defaultTheme';
import AppLocale from '../lngProvider';

import SignIn from './SignIn';
import {setInitUrl} from '../store/actions/Auth';
import ForgotPassword from './ForgotPassword';
import ForgotPasswordDone from './ForgotPasswordDone';
import PasswordRecovery from './PasswordRecovery';
import ResetPasswordDone from './ResetPasswordDone';
import ConfirmEmail from '../app/routes/confirmEmail';

const RestrictedRoute = ({component: Component, authUser, ...rest}) => (
  <Route
    {...rest}
    render={props => (authUser
      ? <Component {...props} />
      : (
        <Redirect
          to={{
            pathname: '/signin',
            state: {from: props.location}
          }}
        />
      ))}
  />
);

class App extends Component {

  componentWillMount() {
    window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
    if (this.props.initURL === ''
      && !(this.props.history.location.pathname.indexOf('password/recovery') > -1)) {
      this.props.setInitUrl(this.props.history.location.pathname);
    }
  }

  render() {
    const {
      match, location, locale, authUser, initURL, isDirectionRTL
    } = this.props;
    if (location.pathname === '/') {
      if (authUser === null) {
        return (<Redirect to="/signin" />);
      } if (initURL === '' || initURL === '/' || initURL === '/signin') {
        return (<Redirect to="/profile" />);
      }
      return (<Redirect to={initURL} />);

    }
    const applyTheme = createMuiTheme(defaultTheme);

    if (isDirectionRTL) {
      applyTheme.direction = 'rtl';
      document.body.classList.add('rtl');
    } else {
      document.body.classList.remove('rtl');
      applyTheme.direction = 'ltr';
    }

    const currentAppLocale = AppLocale[locale.locale];
    return (
      <MuiThemeProvider theme={applyTheme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <IntlProvider
            locale={currentAppLocale.locale}
            messages={currentAppLocale.messages}>
            <RTL>
              <div className="app-main">
                <Switch>
                  <RestrictedRoute
                    path={`${match.url}profile`}
                    authUser={authUser}
                    component={MainApp} />
                  <Route path="/signin" component={SignIn} />
                  <Route path="/forgot_password" component={ForgotPassword} />
                  <Route path="/forgot_password_done" component={ForgotPasswordDone} />
                  <Route path="/password/setup/:uid/:token" component={PasswordRecovery} />
                  <Route path="/reset/done/" component={ResetPasswordDone} />
                  <Route path={"/confirm-email/:uid/:token"} component={ConfirmEmail} />
                  <Route component={asyncComponent(() => import('components/Error404'))} />
                </Switch>
              </div>
            </RTL>
          </IntlProvider>
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    );
  }
}

const mapStateToProps = ({settings, auth}) => {
  const {sideNavColor, locale, isDirectionRTL} = settings;
  const {authUser, initURL} = auth;
  return {
    sideNavColor, locale, isDirectionRTL, authUser, initURL
  };
};

export default connect(mapStateToProps, {setInitUrl})(App);
